<template>
  <div class="latest-warnings bg-white rounded-lg p-5 mt-4 shadow-sm">
    <!-- 头部标题与查看全部 -->
    <div class="header">
      <div class="title-container">
        <!-- <span class="indicator"></span> -->
        <h3 class="title-text">最新设备告警</h3>
      </div>
      <!-- <span class="view-all" @click="goToAll">查看全部</span> -->
    </div>

    <!-- 表格 -->
    <div class="table-container">
      <table class="warnings-table">
        <thead>
          <tr>
            <th>设备名称</th>
            <th>所属项目</th>
            <th>告警类型</th>
            <th>告警时间</th>
            <!-- <th>状态</th> -->
            <th class="text-right">操作</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(row, index) in tableData" :key="index">
            <td class="device-name">{{ row.deviceName }}</td>
            <td class="project-name">{{ row.projectName }}</td>
            <td class="warning-type">
              <span :class="row.typeClass">{{ row.warningType }}</span>
            </td>
            <td class="warning-time">{{ row.time }}</td>
            <!-- <td class="warning-status">
              <span :class="['status-badge', row.statusClass]">{{ row.status }}</span>
            </td> -->
            <td class="operation text-right">
              <span class="btn-detail" @click="viewDetail(row)">详情</span>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>

<script setup>
import { ref, onMounted } from "vue";
import { useRouter } from "vue-router";
import { EquipmentLedgerHomeStats } from "@/api/equipmentLedger.js";

const router = useRouter();

const tableData = ref([]);

const getLatestWarnings = async () => {
  try {
    const res = await EquipmentLedgerHomeStats();
    if (res.code === 200 && res.data) {
      tableData.value = res.data.latestWarnings || [];
    }
  } catch (error) {
    console.error("加载首页最新告警失败:", error);
  }
};

const viewDetail = (row) => {
  console.log("查看详情:", row);
  router.push('/equipment/equipmentDataAcquisition');
};

const goToAll = () => {
  console.log("查看全部");
  router.push('/equipment/equipmentDataAcquisition');
};

onMounted(() => {
  getLatestWarnings();
});
</script>

<style lang="less" scoped>
.latest-warnings {
  background-color: #fff;
  border-radius: 8px;
  padding: 20px;
  margin-top: 15px;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.05);
}

.header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 20px;
}

.title-container {
  display: flex;
  align-items: center;
  gap: 8px;
}

.indicator {
  width: 4px;
  height: 16px;
  background-color: #7e5bfd;
  border-radius: 2px;
}

.title-text {
  font-size: 16px;
  font-weight: bold;
  color: #1a1a1a;
  margin: 0;
}

.view-all {
  font-size: 13px;
  color: #3b82f6;
  cursor: pointer;
  font-weight: 500;
  &:hover {
    color: #2563eb;
    text-decoration: underline;
  }
}

.table-container {
  width: 100%;
  overflow-x: auto;
}

.warnings-table {
  width: 100%;
  border-collapse: collapse;
  text-align: left;
  font-size: 13px;

  th {
    color: #888;
    font-weight: 500;
    padding: 12px 8px;
    border-bottom: 1px solid #f3f4f6;
  }

  td {
    color: #4b5563;
    padding: 14px 8px;
    border-bottom: 1px solid #f9fafb;
    vertical-align: middle;
  }

  tr:hover td {
    background-color: #f9fafb;
  }
}

.text-right {
  text-align: right !important;
}

.device-name {
  font-weight: 500;
  color: #111827 !important;
}

.warning-type {
  .text-red {
    color: #ef4444;
    font-weight: 500;
  }
  .text-orange {
    color: #f97316;
    font-weight: 500;
  }
  .text-gray {
    color: #9ca3af;
  }
}

.warning-time {
  font-family: monospace;
  color: #6b7280;
}

.status-badge {
  display: inline-block;
  padding: 3px 10px;
  font-size: 11px;
  font-weight: bold;
  color: #fff;
  border-radius: 4px;
  text-align: center;

  &.bg-red {
    background-color: #ef4444;
  }
  &.bg-orange {
    background-color: #f97316;
  }
  &.bg-gray {
    background-color: #9ca3af;
  }
}

.btn-detail {
  color: #3b82f6;
  cursor: pointer;
  font-weight: 500;
  &:hover {
    color: #2563eb;
    text-decoration: underline;
  }
}
</style>
